/**
 * Typography design tokens
 */
export const TypographyTokens = {
    fontFamily: {
        primary: "monospace",
        fallback: "Courier New, monospace",
    },

    fontSize: {
        xs: "10px",
        sm: "12px",
        md: "14px",
        base: "15px",
        lg: "16px",
        xl: "20px",
        xxl: "24px",
        xxxl: "32px",
    },

    fontWeight: {
        normal: "normal",
        bold: "bold",
    },

    lineHeight: {
        tight: 1.2,
        normal: 1.5,
        relaxed: 1.8,
    },
};
